import { render, staticRenderFns } from "./StudentTimePlannerAppointments.vue?vue&type=template&id=31753b53"
import script from "./StudentTimePlannerAppointments.vue?vue&type=script&lang=ts"
export * from "./StudentTimePlannerAppointments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports